import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import TableChartIcon from '@mui/icons-material/TableChart';

import FTEPlanPage from './FTEPlanPage';
import OretPage    from './OretPage';

export default function FTEPlanOretHub() {
  const location = useLocation();
  const history  = useHistory();

  const tab = location.pathname.startsWith('/oret') ? 'oret' : 'fte';

  const handleChange = (_, next) => {
    if (next === tab) return;
    history.push(next === 'oret' ? '/oret' : '/fte-plan');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box
        sx={{
          borderBottom: '1px solid',
          borderColor:  'divider',
          bgcolor:      'background.paper',
          px:           tab === 'oret' ? 2 : 0,
          pt:           tab === 'oret' ? 1 : 0,
          flexShrink:   0,
        }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          sx={{ minHeight: 38, '& .MuiTab-root': { minHeight: 38 } }}
        >
          <Tab
            value="fte"
            label="Plani"
            icon={<FolderOpenIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem' }}
          />
          <Tab
            value="oret"
            label="Orët"
            icon={<TableChartIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.85rem' }}
          />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, ...(tab === 'fte' && { pt: 1.5 }) }}>
        {tab === 'fte' ? <FTEPlanPage /> : <OretPage />}
      </Box>
    </Box>
  );
}
